module.exports = __webpack_public_path__ + "static/bn-e1882e0d1a24b1cf738cae33f46ed517.svg";